// Todo:
/*
Previously This ENUM was defined under this path "src/app/modules/clm/types/claim-type.ts" but
now this needs to be used globally by this Member Dialog therefore added todo note to make it
refactor in next PR
*/

export enum ClaimType {
  Claim = 'Claim',
  Authorisation = 'Authorisation',
}
